import { Stack, Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { MarkProvisionCompletePrimaryAction } from 'components/core/task-list-v2/task-list-v2-components/MarkProvisionCompletePrimaryAction'
import { TaskPrimaryActionsButton } from 'components/core/task-list-v2/task-list-v2-components/styles'
import { TaskPrimaryActionsV2Variant } from 'components/core/task-list-v2/task-list-v2-components/TaskPrimaryActionsV2'
import { TaskValue } from 'lib/actions/task'
import { TriangleAlert } from 'lucide-react'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const AccountDeletedPrimaryAction: FC<{ task: TaskValue, variant: TaskPrimaryActionsV2Variant }> = ({ task, variant }) => {
    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <C1Icon icon={TriangleAlert} sx={TaskPrimaryActionsButton.warningIcon} />
            <Typography>
                <FormattedMessage id="task_app_user_deleted" defaultMessage="Account deleted" />
            </Typography>
            <MarkProvisionCompletePrimaryAction task={task} variant={variant} />
        </Stack>
    )
}
